import React from 'react'
import c from 'classnames'

import Icon from 'discada/dist/Icon'

import './Chip.scss'

export function ChipBody({ onClick = () => {}, bg, placeholderBg, children }) {
  return (
    <div
      className={c('frikin-chip-body', { 'has-image': !!bg })}
      onClick={onClick}
      style={bg ? { backgroundImage: `url(${bg || placeholderBg})` } : {}}
    >
      {children}
    </div>
  )
}

export function ChipInfo({ onClick = () => {}, style, children }) {
  return (
    <div className="frikin-chip-info" onClick={onClick} style={style}>
      <div className="frikin-chip-info-inner">{children}</div>
    </div>
  )
}

export default function Chip({ className, isLoading, children, mini }) {
  return (
    <div
      className={c('frikin-chip', className, {
        'is-loading': isLoading,
        'is-mini': mini,
      })}
    >
      {isLoading ? (
        <Icon icon="hourglass-half" className="loading-placeholder" />
      ) : (
        children
      )}
    </div>
  )
}
